import setClinic from './setClinic';
import setClinics from './setClinics';

export default {
  setClinic,
  setClinics,
};
